import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const BlogList = () => {
  const [posts, setPosts] = useState([]);
  const currentUser = useSelector(state => state.userLogin.userInfo);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const response = await axios.get('https://api.andrewslearning.com/api/posts/');
      const sortedPosts = response.data.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
      setPosts(sortedPosts);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeletePost = async (postId) => {
    try {
      await axios.delete(`https://api.andrewslearning.com/api/posts/${postId}/`);
      const updatedPosts = posts.filter((post) => post.id !== postId);
      setPosts(updatedPosts);
    } catch (error) {
      console.error(error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US');
  };

  return (
    <div>
      <h1 id="Posts">Blog</h1>
      <div className="card-container">
        {posts.map((post) => (
          <div key={post.id} className="card">
            <img src={post.image} alt={post.title} className="card-image" />
            <div className="card-content">
              <h2 className="card-title">
                <Link to={`/posts/${post.id}`}>{post.title}</Link>
              </h2>
              <p className="card-info">
                Date: {formatDate(post.timestamp)} | Author: {post.author.username}
              </p>
              <p className="card-snippet">{post.snippet}</p>
              {currentUser && post.author.username === currentUser.username && (
                  <button onClick={() => handleDeletePost(post.id)}>Delete</button>
              )}
            </div>
          </div>
        ))}
      </div>
      <br /><br /><br /><br /><br /><br />
    </div>
  );
};

export default BlogList;
